import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthProvider'
import { Button } from '@/components/ui/button'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import ProfileSwitcher from '@/components/ProfileSwitcher'
import { LogOut, BookOpen, FileText, ShieldCheck, ChevronRight } from 'lucide-react'

export default function MorePage() {
  const { userProfile, company, signOut } = useAuth()
  const navigate = useNavigate()

  const initials = userProfile
    ? `${userProfile.first_name?.[0] || ''}${userProfile.last_name?.[0] || ''}`
    : ''

  return (
    <div className="p-4 space-y-5">
      {/* Profile card */}
      <button
        onClick={() => navigate('/more/profile')}
        className="w-full bg-white rounded-xl border border-gray-200 p-5 flex items-center gap-4 text-left active:bg-gray-50 transition-colors"
      >
        <Avatar className="h-14 w-14">
          <AvatarImage src={userProfile?.avatar_url} />
          <AvatarFallback className="bg-emerald-100 text-emerald-700 text-lg font-medium">
            {initials}
          </AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-gray-900 truncate">
            {userProfile?.first_name} {userProfile?.last_name}
          </p>
          <p className="text-sm text-gray-500 truncate">{company?.name}</p>
          <p className="text-xs text-gray-400 truncate">{userProfile?.email}</p>
        </div>
        <ChevronRight className="h-4 w-4 text-gray-300 shrink-0" />
      </button>

      {/* Navigation links */}
      <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
        <button
          onClick={() => navigate('/bookings')}
          className="w-full flex items-center justify-between px-4 py-3.5 text-sm text-gray-700 active:bg-gray-50 transition-colors"
        >
          <span className="flex items-center gap-3">
            <BookOpen className="h-4 w-4 text-gray-400" />
            Bookings
          </span>
          <ChevronRight className="h-4 w-4 text-gray-300" />
        </button>
        <button
          onClick={() => navigate('/more/documents')}
          className="w-full flex items-center justify-between px-4 py-3.5 text-sm text-gray-700 active:bg-gray-50 transition-colors"
        >
          <span className="flex items-center gap-3">
            <FileText className="h-4 w-4 text-gray-400" />
            Documents
          </span>
          <ChevronRight className="h-4 w-4 text-gray-300" />
        </button>
        <button
          onClick={() => navigate('/more/policies')}
          className="w-full flex items-center justify-between px-4 py-3.5 text-sm text-gray-700 active:bg-gray-50 transition-colors"
        >
          <span className="flex items-center gap-3">
            <ShieldCheck className="h-4 w-4 text-gray-400" />
            Policies
          </span>
          <ChevronRight className="h-4 w-4 text-gray-300" />
        </button>
        <ProfileSwitcher />
      </div>

      {/* Sign out */}
      <Button
        variant="outline"
        className="w-full text-red-600 border-red-200 hover:bg-red-50"
        onClick={signOut}
      >
        <LogOut className="h-4 w-4 mr-2" />
        Sign Out
      </Button>
    </div>
  )
}
